// extracted by mini-css-extract-plugin
export default {"burgerMenu":"BurgerMenu_burgerMenu__0RPzU"};